import { InventoryCountItemTemplateCreatePage } from "@/features/inventory-count-template-item/pages/InventoryCountItemTemplateCreatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/admin/inventory-count-template-item/create",
)({
  beforeLoad({ context }) {
    if (
      !context.authAdapter.can({ permissions: ["inventory_count_item_template.create"] })
    ) {
      throw redirect({ to: "/403" });
    }
  },
  component: InventoryCountItemTemplateCreatePage,
});
